import * as React from 'react';
import { clsx } from 'clsx';
import { Layout } from '../../Layout';
import * as styles from './DefaultIntroduction.css';

interface IDefaultIntroductionProps {
  backgroundImage: React.ReactNode;
  title: React.ReactNode;
  logo: React.ReactNode;
  contacts: React.ReactNode;
  facts: React.ReactNode;
  hasPoster: boolean;
}

export function DefaultIntroduction({
  hasPoster,
  backgroundImage,
  logo,
  title,
  facts,
  contacts,
}: IDefaultIntroductionProps) {
  return (
    <section id="main" className={clsx(styles['introduction'])}>
      <div className={clsx(styles['image'], { [styles['substrate']]: hasPoster })}>{backgroundImage}</div>

      <div className={styles['content']}>
        <Layout>
          <div className={styles['content__wrapper']}>
            <div className={styles['logo']}>{logo}</div>
            <div className={styles['middle']}>
              <div className={styles['title']}>{title}</div>

              {facts}
            </div>

            {contacts}
          </div>
        </Layout>
      </div>
    </section>
  );
}
